import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import VendorSidebar from '../VendorSidebar';
import VendorHeader from '../VendorHeader';
import VendorLocationAlertBanner from '../../vendor/VendorLocationAlertBanner';
import { useSidebar } from '../../../contexts/SidebarContext';
import { useAuth } from '../../../contexts/AuthContext';
import useVendorPlanAccess from '../../../hooks/useVendorPlanAccess';
import { isSubscriptionExemptPath } from '../../../utils/vendorPlanAccess';
import { useSubscription } from '../../../contexts/SubscriptionContext';
import { Loader2 } from 'lucide-react';
import ChatWidget from '../ChatWidget';
import ProductShell from '../product/ProductShell';

const VendorLayout = () => {
  const location = useLocation();
  const { isVendorSidebarCollapsed, isVendorMobileSidebarOpen } = useSidebar();
  const { user, isLoading: authLoading } = useAuth();
  const { isLoading: planAccessLoading, canAccessPath, hasActiveSubscription } = useVendorPlanAccess();
  const { subscriptionExpired, isChecking: subscriptionChecking } = useSubscription();

  if (authLoading) {
    return (
      <ProductShell className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <Loader2 className="mx-auto mb-4 h-8 w-8 animate-spin text-ink" />
          <p className="text-ink-secondary">Loading...</p>
        </div>
      </ProductShell>
    );
  }

  if (user?.user_type === 'vendor' && (planAccessLoading || subscriptionChecking)) {
    return (
      <ProductShell className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <Loader2 className="mx-auto mb-4 h-8 w-8 animate-spin text-ink" />
          <p className="text-ink-secondary">Checking plan access...</p>
        </div>
      </ProductShell>
    );
  }

  if (
    user?.user_type === 'vendor' &&
    (subscriptionExpired || hasActiveSubscription === false) &&
    !isSubscriptionExemptPath(location.pathname)
  ) {
    return <Navigate to="/vendor/subscription" replace />;
  }

  if (user?.user_type === 'vendor' && !canAccessPath(location.pathname)) {
    return <Navigate to="/vendor/subscription" replace />;
  }

  return (
    <ProductShell>
      <div className="product-shell-row">
        <VendorSidebar />
        <div
          className={`product-main ${
            isVendorSidebarCollapsed ? 'is-collapsed' : ''
          } ${isVendorMobileSidebarOpen ? 'is-mobile-open' : ''}`}
        >
          <div className="product-main-frame">
            <VendorHeader />
            <main className="dashboard-main flex-1 min-w-0">
              <div className="product-page vendor-page min-w-0 max-w-full">
                <VendorLocationAlertBanner />
                <Outlet />
              </div>
            </main>
          </div>
        </div>
      </div>
      <ChatWidget />
    </ProductShell>
  );
};

export default VendorLayout;
